module.exports = "/fonts/vendor/quasar-extras/fontawesome/fa-brands-400.woff2?659c4d58b00226541ef95c3a76e169c5";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/fontawesome/fa-brands-400.woff2
// module id = bbfG
// module chunks = 49